import { Injectable } from '@angular/core';
 import { CanDeactivate } from '@angular/router';
 import { Observable } from 'rxjs';
 
 export interface CanLeavePage {
   canLeave: () => Observable<boolean> | Promise<boolean> | boolean;
 }
 
 @Injectable({
   providedIn: 'root'
 })
 export class CanLeaveStateService {
   private checkedComponents = new Set<string>();
 
   hasChecked(component: any): boolean {
     if (!component) return false;
     const componentName = component.constructor.name;
     return this.checkedComponents.has(componentName);
   }
 
   markAsChecked(component: any): void {
     if (!component) return;
     const componentName = component.constructor.name;
     this.checkedComponents.add(componentName);
   }
 
   clearChecked(component: any): void {
     if (!component) return;
     const componentName = component.constructor.name;
     this.checkedComponents.delete(componentName);
   }
 }
 
 @Injectable({
   providedIn: 'root'
 })
 export class CanLeaveGuard implements CanDeactivate<CanLeavePage> {
   constructor(private stateService: CanLeaveStateService) {}
 
   canDeactivate(
     component: CanLeavePage
   ): Observable<boolean> | Promise<boolean> | boolean {
     
     // If component is null, check if we've already processed this navigation
     if (!component) {
       // Since we can't get the component name, we'll assume this is part of the same navigation
       // and allow it to proceed
       return true;
     }
     
     if (typeof component.canLeave !== 'function') {
       return true;
     }
     
     const result = component.canLeave();
     
     // Mark that we've checked this component
     this.stateService.markAsChecked(component);
     
     return result;
   }
 }